import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';

dayjs.extend(isToday);

export default function isDateToday(date?: dayjs.Dayjs | null): boolean {
  if (!date) {
    return false;
  }

  return dayjs(date).isToday();
}
